import AttributeContainer from "../../containers/AttributeContainer";
import AttributeListContainer from "../../containers/AttributeListContainer";
import GroupContainer from "../../containers/GroupContainer";
import GroupListContainer from "../../containers/GroupListContainer";
import LocationContainer from "../../containers/LocationContainer";
import LocationListContainer from "../../containers/LocationListContainer";
import WorkflowContainer from "../../containers/WorkflowContainer";
import WorkflowListContainer from "../../containers/WorkflowListContainer";

export class UserCategoriesGenericConstants {
  static readonly Tabs = [
    {
      headerKey: "userCategories.label.groups",
      addLabelKey: "userCategories.label.addGroup",
      editLabelKey: "userCategories.label.editGroup",
      listComponent: GroupListContainer,
      sidebarComponent: GroupContainer,
    },
    {
      headerKey: "userCategories.label.attributes",
      addLabelKey: "userCategories.label.addAttribute",
      editLabelKey: "userCategories.label.editAttribute",
      listComponent: AttributeListContainer,
      sidebarComponent: AttributeContainer,
    },
    {
      headerKey: "userCategories.label.workflows",
      addLabelKey: "userCategories.label.addWorkflow",
      editLabelKey: "userCategories.label.editWorkflow",
      listComponent: WorkflowListContainer,
      sidebarComponent: WorkflowContainer,
    },
    {
      headerKey: "userCategories.label.locations",
      addLabelKey: "userCategories.label.addLocation",
      editLabelKey: "userCategories.label.editLocation",
      listComponent: LocationListContainer,
      sidebarComponent: LocationContainer,
    },
  ];
}
